<!-- 表格行-鼠标右键菜单页代码  contextButton.vue -->
<template>
    <div id="contextmenu" class="contextmenu">
        <div class="contextmenu__item" v-for="(item, index) in menuList" :key="index" @click="handleMenu(item)">
            {{ item.title }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'contextMenu',
        props: {
        menuList: {
            type: Array
        },

    },
    data() {
        return {
            // menuList: [
            //     { title: '菜单一', value: 0, command: 'first' },
            //     { title: '菜单二', value: 1, command: 'second' },
            //     { title: '菜单三', value: 2, command: 'third' },
            //     { title: '菜单四', value: 3, command: 'fourth' }
            // ],
            row:null,//传进来的数据
        };
    },
    mounted() {

    },
    methods: {
        init(row, column, event,returnVal) {
            this.row=row;
            // 设置菜单出现的位置
            // 具体显示位置根据自己需求进行调节
            let menu = document.querySelector('#contextmenu');
            let cha = document.body.clientHeight - event.clientY;
            menu.style.top = event.clientY- 80 + 'px'
            menu.style.left = event.clientX - 200 + 'px';
            // 给整个document添加监听鼠标事件，点击任何位置执行方法
            document.addEventListener('click', this.menuListen); 
            
        },
        menuListen() {
            this.$emit('menuListen');
        },
        handleMenu(item) {
            var data={item:item,row:this.row};
            this.$emit('handleMenu', data);
        }
    }
};
</script>

<style scoped>
.contextmenu__item {
    display: block;
    line-height: 34px;
    text-align: center;
}
.contextmenu__item:not(:last-child) {
    border-bottom: 1px solid rgba(64, 158, 255, 0.2);
}
.contextmenu {
    position: absolute;
    background-color: #ecf5ff;
    width: 100px;
    /*height: 106px;*/
    font-size: 12px;
    color: #409eff;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 1px solid rgba(64, 158, 255, 0.2);
    white-space: nowrap;
    z-index: 1000;
}
.contextmenu__item:hover {
    cursor: pointer;
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
}
</style>
